// extracted by mini-css-extract-plugin
export default {"done-icon":"styles_done-icon__q-dq+","gtin-alert-icon":"styles_gtin-alert-icon__3Nq0V"};